var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMenuExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M25.818,14.193l-4.736-4.736c-0.396-0.396-1.039-0.396-1.436,0c-0.396,0.396-0.396,1.039,0,1.436 l3.004,3.004H10.213c-0.561,0-1.016,0.455-1.016,1.016s0.455,1.016,1.016,1.016H22.65l-3.004,3.004 c-0.396,0.396-0.396,1.039,0,1.436c0.199,0.199,0.457,0.297,0.719,0.297c0.258,0,0.52-0.098,0.717-0.297l4.736-4.736 C26.215,15.234,26.215,14.591,25.818,14.193z M14.951,24.049H7.166V5.775h7.785c0.559,0,1.014-0.455,1.014-1.016 s-0.455-1.016-1.014-1.016H6.152c-0.563,0-1.016,0.455-1.016,1.016v20.305c0,0.561,0.453,1.016,1.016,1.016h8.799 c0.559,0,1.014-0.455,1.014-1.016S15.51,24.049,14.951,24.049z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuExit);
export default __webpack_public_path__ + "static/media/user_menu_exit.4fe2970747f8530f6889be180affea53.svg";
export { ForwardRef as ReactComponent };